import cn from 'clsx';

type Props = {
  isOpen: boolean;
};

export default function BackgroundOverlay({ isOpen }: Props) {
  return <div className={cn('bg-slate-900/80 h-screen w-screen fixed z-[240] lg:hidden', { hidden: !isOpen })} />;
}
